import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import LeftCaret from './LeftCaret';
import { BackHyperLink, BackLinkText, BackLinkArrow } from './BackLink.styles';
import { AppRoute } from '../../../constants';

const BackLink = ({
  backLinkText,
  backLinkTrackEvent = '',
  backLinkRoute = '',
}: {
  backLinkText: string;
  backLinkTrackEvent?: string;
  backLinkRoute?: string;
}) => {
  const history = useHistory();
  const { trackEvent } = useContext(AnalyticsContext);

  const routeBack = () => {
    if (backLinkTrackEvent) {
      trackEvent(`${backLinkTrackEvent}`);
      datadogRum.addAction(`${backLinkTrackEvent}`);
    }
    const route = backLinkRoute || AppRoute.MY_CARVANA;
    history.push(route);
  };

  return (
    <BackHyperLink onClick={routeBack} data-testid="back-link">
      <BackLinkArrow>
        <LeftCaret />
      </BackLinkArrow>
      <BackLinkText data-testid="back-link-text">{backLinkText}</BackLinkText>
    </BackHyperLink>
  );
};

export default BackLink;
